import React from "react";
import {Route, Routes} from "react-router-dom";
import {MercatorDrawPage} from "@/pages/mercator-draw";

export const MercatorDrawRoutes = () => {
    return (
        <Routes>
            <Route path="/" element={<MercatorDrawPage />} />
        </Routes>
    );
};
